import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { editDeviation } from '../../redux/deviations/actionCreators';
var mapStateToProps = function (state, _a) {
    var tier = _a.tier;
    return {
        isOwner: getIsCurrentUserAuthorOf(state, tier),
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.tier;
    return ({
        onClick: function () { return dispatch(editDeviation({ deviation: deviation })); },
    });
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=EditTierButton.container.js.map